<template>
  <div class="postbox">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/buergerkonto">Bürgerkonto</router-link>
      <router-link to="/buergerkonto/postbox">Postbox</router-link>
    </Breadcrumb>
    <div class="postbox__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/buergerkonto" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="postBox" color="detailed" class="hide-mobile"/>
          <Headline subline="Ihr Augsburger Bürgerkonto" headline="Bürgerkonto-Postbox" />
        </div>
        <div class="headline-link__right hide-mobile">
          <form @submit.prevent="filterList" class="input-wrapper">
            <input type="search" placeholder="Miteilungen durchsuchen..." v-model="searchTerm">
            <Icon icon="search" @click.native="filterList"/>
          </form>
        </div>
      </div>
    </div>
    <div class="postbox__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs">
        <div class="postbox__content__left col-xs-12 col-md-8">
          <div v-if="filteredMessages.length < 1" class="no-messages">
            <Icon icon="postBox" color="detailed" />
            <div class="text">
              <h6>Keine Mitteilungen</h6>
              <p>Es befinden sich aktuell keine Mitteilungen in Ihrer Postbox</p>
            </div>
          </div>
          <div v-for="message in filteredMessages" :key="message.id" v-show="message.id == messageId" class="message">
            <div class="message__header">
              <div class="header-row">
                <h6>{{ message.author }}</h6>
                <Icon icon="trash" title="Nachricht löschen" @click.native="removeMessage(message.id)"/>
              </div>
              <div class="header-row">
                <p>{{ message.subject }}</p>
                <p class="hide-mobile">{{ message.date }} - {{ message.time }}</p>
              </div>
            </div>
            <div class="message__content">
              <p style="white-space: pre-line;">{{ message.message }}</p>
              <span>Dies ist eine automatisch generierte Mitteilung Ihres Bürgerportals</span>
            </div>
          </div>
        </div>

        <div class="postbox__content__sidebar col-xs-12 col-md-3">
          <div class="margin-bottom--30">
            <div v-for="message in filteredMessages" :key="message.id" class="nav-element" @click="readMessage(message.id)" :class="{ 'new' : !message.read, 'selected' : messageId == message.id }">
              <div class="first-row">
                <p>{{ message.author }}</p>
                <span>{{ message.date }}</span>
              </div>
              <p>{{ message.subject }}</p>
            </div>
          </div>
          <div class="new-message">
            <Button text="Neue Nachricht..." type="primary" @click.native="toggleModal"/>
          </div>

          <Modal v-if="showMessageModal" @closeModal="toggleModal" :outside="true">
            <Card padding="35px" class="modal-new">
              <Headline subline="Neue Nachricht schreiben" headline="Leider nicht möglich"/>
              <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
            </Card>           
          </Modal>
        </div>
      </div>
    </div>

    <Teaser illu="postbox" subline="Ihre direkter Draht zu Augsburgs Behörden" headline="Sicher kommunizieren">
      <p>Durch Ihre Postbox erhalten Sie Mitteilungen über Neuigkeiten aus Ihrem Bürgerkonto aber auch Neuigkeiten der Stadt die Sie betreffen. Alle Nachrichten gelangen verschlüselt über unseren Server zu Ihnen und können nur von Ihnen persöhnlich gelesen werden. So schützen wir Ihre persönlichen Daten und sorgen für die nötige Privatssphäre auf Ihrem Bürgerkonto.</p>
    </Teaser>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';


export default {
  name: 'Postbox',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
  },
  data() {
    return {
      searchTerm: '',
      userMessages: null,
      suggestedServices: null,
      messageId: null,
      filteredMessages: null,
      showMessageModal: false,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      getAllMessages: 'messages/getAllMessages',
      getMessageById: 'messages/getMessageById',
      getMessagesByIds: 'messages/getMessagesByIds',
      getMessagesByTitle: 'messages/getMessagesByTitle',
    }),
  },
  methods: {
    ...mapActions({
      checkMessage: 'messages/checkMessage',
      deleteMessage: 'messages/deleteMessage',
    }),
    filterList() {
      if(this.searchTerm == '') {
        this.filteredMessages = this.userMessages;
        this.messageId = this.filteredMessages[0].id;
      } else {
        this.filteredMessages = this.userMessages.filter(message => message.subject.toLowerCase().includes(this.searchTerm.toLowerCase()) 
        || message.author.toLowerCase().includes(this.searchTerm.toLowerCase()));
        if(this.filteredMessages.length > 0) {
          this.messageId = this.filteredMessages[0].id;
        }
      }
    },
    readMessage(id) {
      this.messageId = id;
      this.checkMessage(id);
    },
    removeMessage(id) {
      this.deleteMessage(id);
      this.userMessages = this.getMessagesByIds(this.activeUser.id);
      this.filteredMessages = this.userMessages;
      this.messageId = this.filteredMessages[0].id;
    },
    toggleModal() {
      this.showMessageModal = !this.showMessageModal;
    }
  },
  created() {
    this.userMessages = this.getMessagesByIds(this.activeUser.id);
    this.filteredMessages = this.userMessages;
    this.messageId = this.filteredMessages[0].id;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Postbox.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Postbox/Postbox.vue